<template>
  <div class="filters-container">
    <Lansstyrelse v-bind="filters" @change="onChange" />
    <Status v-bind="filters" @change="onChange" />
    <Year v-bind="filters" @change="onChange" />
  </div>
</template>

<script>
import Lansstyrelse from './Lansstyrelse.vue'
import Status from './Status.vue'
import Year from './Year.vue'

export default {
  name: 'FiltersLansrapporter',
  props: {
    filters: { type: Object },
  },
  components: {
    Lansstyrelse,
    Status,
    Year,
  },
  methods: {
    onChange(filter) {
      this.$emit('change', filter)
    },
  },
}
</script>

<style lang="less" scoped>
.filters-container {
  display: flex;
  gap: 10px;
}
</style>
